import _ from 'lodash';

export const alertsAdapter = (vincheck) => _.get(vincheck, 'recordAlerts', null);
